import * as GLOBALS from '../globals';

export default class DropdownMenu {

	static init() {
		return new DropdownMenu();
	}

	constructor() {
		document.querySelectorAll('select').forEach((select) => {
			select.addEventListener('change', () => select.blur());
		});

		window.dropdown = this.initSelect;
	}

	initSelect() {
		return {
			data: [],
			disabled: false,
			domElement: null,
			emptyOptionsMessage: 'Keine Ergebnisse gefunden',
			focusedOptionIndex: null,
			multiple: null,
			open: false,
			options: [],
			placeholder: 'Auswählen...',
			search: '',
			useTagMultiselect: true,
			value: null,

			get filteredValue() {
				let options = Object.keys(this.options);

				if (this.multiple)
					return (this.value ?? []).filter((value) => {
						return options.includes(value);
					});


				if (!options.includes(this.value)) return null;

				return this.value;
			},

			get hasValue() {
				return this.multiple
					? (Array.isArray(this.value) && this.value.length > 0)
					: this.value;
			},

			get isMobileDevice() {
				return GLOBALS.IS_MOBILE_DEVICE;
			},

			get selectionSummary() {
				let value = this.filteredValue;

				if (this.multiple & this.useTagMultiselect)
					return this.placeholder;

				if (this.multiple & !this.useTagMultiselect) {
					value = value.map((key) => {
						return this.options[key];
					});

					return value.join(', ');
				}

				if (!this.multiple && value)
					return this.options[value];

				return this.placeholder;
			},

			isSelected: function (key) {
				if (this.multiple)
					return (this.value ?? []).includes(key);
				else return this.value == key;
			},

			closeListbox: function () {
				this.open = false;
				this.focusedOptionIndex = null;
				this.search = '';
			},

			// handles value changes in DOM-Element (select)
			domElementValueChanged: function () {
				if (this.multiple)
					this.value = [...this.domElement.options].filter(option => option.selected).map(option => option.value);
				else this.value = this.domElement.value;
			},

			// next item in list will be focused when arrow-down is pressed
			focusNextOption: function () {
				if (this.focusedOptionIndex === null) return this.focusedOptionIndex = Object.keys(this.options).length - 1;

				if (this.focusedOptionIndex + 1 >= Object.keys(this.options).length) return;

				this.focusedOptionIndex++;

				this.$refs.listbox.children[this.focusedOptionIndex].scrollIntoView({
					block: "nearest"
				});
			},

			// previous item in list will be focused when arrow-up is pressed
			focusPreviousOption: function () {
				if (this.focusedOptionIndex === null) return this.focusedOptionIndex = 0;

				if (this.focusedOptionIndex <= 0) return;

				this.focusedOptionIndex--;

				this.$refs.listbox.children[this.focusedOptionIndex].scrollIntoView({
					block: "nearest"
				});
			},

			// setup of custom dropdown using existing values from inner SELECT-element (DOM-Element)
			initDropdown: function (el) {
				this.domElement = el.querySelector('select');
				this.updateOptions();

				this.multiple = !!this.domElement.hasAttribute('multiple');
				this.placeholder = this.domElement.getAttribute('placeholder') ? this.domElement.getAttribute('placeholder') : this.placeholder;

				this.domElement.addEventListener('change', this.domElementValueChanged.bind(this));

				// poll domElement changes every 500ms
				setInterval(() => {
					this.updateOptions();
					this.disabled = this.domElement.disabled;
				}, 500);

				this.$nextTick(this.domElementValueChanged.bind(this));
				this.$watch('search', this.searchChanged.bind(this));
				this.$watch('value', this.updateDomElement.bind(this));
			},

			// removes an item from multi-selection
			removeItem: function (key) {
				if (!this.multiple) return;

				this.value = this.value.filter(function (item) {
					return item !== key;
				});
				this.updateDomElement();
				this.triggerChange();
			},

			// filters the selection list based on current search term 
			searchChanged: function (term) {
				if (!this.open || !term || typeof term !== 'string') return this.options = this.data;

				this.options = Object.keys(this.data)
					.filter((key) => this.data[key].toLowerCase().includes(term.toLowerCase()))
					.reduce((options, key) => {
						options[key] = this.data[key];
						return options;
					}, {});
			},

			// handles value selection for single and multiple choice
			selectOption: function () {
				if (!this.open)
					return this.toggleListboxVisibility();

				let selectedValue = Object.keys(this.options)[this.focusedOptionIndex];

				if (this.multiple) {

					if (!selectedValue)
						this.value = [];

					// remove item if user unselected it
					if (this.value.includes(selectedValue))
						this.removeItem(selectedValue);
					// otherwise add it
					else this.value.push(selectedValue);

					// remove empty values
					this.value = this.value.filter(function (item) {
						return item != '';
					});
				}
				else this.value = selectedValue;

				this.closeListbox();
				this.triggerChange();
			},

			// shows/hides the selection list
			toggleListboxVisibility: function () {
				if (this.open)
					return this.closeListbox();

				this.focusedOptionIndex = Object.keys(this.options).indexOf(this.multiple ? this.value[0] : this.value);

				if (this.focusedOptionIndex < 0)
					this.focusedOptionIndex = 0;

				this.open = true;

				setTimeout(() => {
					this.$refs.search.focus();

					this.$refs.listbox.children[this.focusedOptionIndex].scrollIntoView({
						block: "nearest"
					});
				}, 100);
			},

			triggerChange: function() {
				this.$nextTick(() => {
					this.domElement.dispatchEvent(new Event('change', { 'bubbles': true }));
				});
			},

			// updates the DOM-Element with the currently selected value(s)
			updateDomElement: function () {				
				let options = [...this.domElement.options];

				if (this.multiple)
					options.forEach((option) => {
						option.selected = this.value.some(v => v == option.value);
					});
				else this.domElement.value = this.value;
			},

			
			// loads all available options from DOM-element
			updateOptions: function () {
				if (this.open) return;

				const domOptions = [...this.domElement.options];
				const data = [];

				domOptions.forEach((option) => {
					data[option.value] = option.text;
				});
				this.data = this.options = data;
			},
		}
	}
}
